interface Props {
    color?: string
}

export function SwitchIcon(props: Props) {
    return (
        <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
            <path d="M15 1L19 5M19 5L15 9M19 5H5C3.93913 5 2.92172 5.42143 2.17157 6.17157C1.42143 6.92172 1 7.93913 1 9V11M5 23L1 19M1 19L5 15M1 19H15C16.0609 19 17.0783 18.5786 17.8284 17.8284C18.5786 17.0783 19 16.0609 19 15V13" stroke={props.color ? props.color : "#8383AD"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
